export const WORKFLOW_REDUCER_NAMESPACE = "workflowNextReducer";

const ERROR_IDS = {
  NO_COMPONENT: "No such component",
  NO_WORKFLOW: "No such workflow",
};

export default ERROR_IDS;
